{
	"action": {
		"back": "Back",
		"cancel": "Cancel",
		"close": "Close",
		"confirm": "Confirm",
		"continue": "Continue",
		"delete": "Delete",
		"gotIt": "Got it",
		"ok": "OK",
		"open": "Open",
		"proceed": "Proceed",
		"rename": "Rename",
		"reset": "Reset",
		"retry": "Retry",
		"skip": "Skip",
		"stay": "Stay",
		"update": "Update",
		"create": "Create"
	},
	"error": {},
	"label": {
		"or": "Or"
	},
	"misc": {},
	"prompt": {},
	"status": {}
}
